export default __webpack_public_path__ + "static/media/get_logo.9c5857c8.png";